import { Component, Input, OnInit } from "@angular/core";
import { GenericErrorOps } from './interfaces/generic-error-ops.interface';
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from "@angular/common";
import { DsButtonV2Component, DsCardComponent, DsIconComponent } from "@customdesignsystem";
import { Router, RouterLink } from "@angular/router";
import { GtmService } from "@services/gtm/gtm.service";

@Component({
    selector: "app-ds-generic-error",
    templateUrl: "./generic-error.component.html",
    styleUrls: ["./generic-error.component.scss"],
    animations: [
        trigger("myInsertRemoveTrigger", [
            transition(":enter", [
                style({ opacity: 0 }),
                animate("500ms ease-in-out", style({ opacity: 1 })),
            ]),
        ]),
    ],
    imports: [DsIconComponent, CommonModule, DsButtonV2Component, DsCardComponent, RouterLink],
    standalone: true
})
export class DsGenericErrorComponent implements OnInit {


    @Input() ops: GenericErrorOps;
    readonly helpLinks = {
        phone: {
            type: 'phone' as const,
            text: '600 6600 900',
            url: 'tel:+566006600900',
            gtmLabel: 'Telefono',
            elemento: 'link_telefono',
            elemento_tipo: 'link_externo',
            destino: 'tel:6006600900'
        },

        whatsapp: {
            type: 'whatsapp' as const,
            text: '+569 3639 1222',
            url: 'https://wa.me/56936391222',
            target: '_blank' as const,
            gtmLabel: 'WhatsApp',
            elemento: 'link_whatsapp',
            elemento_tipo: 'link_externo',
            destino: 'https://wa.me/56936391222'
        },

        video: {
            type: 'internal' as const,
            text: 'Video Atención',
            url: '/video-atencion',
            gtmLabel: 'Video Atención',
            elemento: 'link_video_atencion_ayuda',
            elemento_tipo: 'link_interno',
            destino: '/video-atencion'
        }
    };
    constructor(private readonly router: Router, private readonly gtmService: GtmService) { }

    ngOnInit(): void {
        this.gtmService.handleStepTransition({
            paso_numero: 'pre_0',
            paso_nombre: 'atencion_ejecutivo_65anos',
            event_name: 'tramite_invalidez'
        });

        this.gtmService.trackGenericEvent('view', 'Vista de página', 'Vista de página', '-', this.router.url, this.ops.motivo);
    }
    goToPage(elemento: string, texto: string, elemento_tipo: string, url: string) {
        this.gtmService.trackClick(elemento, texto, elemento_tipo, url);
        this.router.navigate([`/${url}`]);
    }

    onHelpClick(link: any): void {

        this.gtmService.trackClick(
            link.elemento,
            link.gtmLabel,
            link.elemento_tipo,
            link.destino
        );
    }
}
